
export const transformReceipt = (brk, step) => {
    // console.log(`transformReceipt`, brk.platform )

    // determine how to show the email field based on platform
    // note: I'm using strings instead of booleans here bc I can see a world 
    // where the mode is "hidden"
    step.receiptVerificationCampaign.rewards && step.receiptVerificationCampaign.rewards.forEach((reward, i) => {
        step.receiptVerificationCampaign.rewards[i].emailFieldMode = "disabled"    // TODO: move these to "types" somewhere
        if (brk.platform === "EMBED") {
            step.receiptVerificationCampaign.rewards[i].emailFieldMode = "enabled"
        }
    
    })

    return step
}